import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';

import { injectCatchHttpError } from '../../../../core/errors/catch-http-error.util';
import { UserTypeEnum } from '../../../../user/models/user';
import { ApiExternalSharingService } from '../services/api-external-sharing.service';
import { getExternalSources, setExternalSources } from './external-sharing.actions';
import { CurrentUserService } from '../../../../user/services/current-user.service';

@Injectable()
export class ExternalSharingEffects {
  private apiExternalSharingService = inject(ApiExternalSharingService);
  private currentUser = inject(CurrentUserService);

  private readonly actions$ = inject<Actions>(Actions);
  private readonly catchHttpError = injectCatchHttpError();

  getExternalSources$ = createEffect(() =>
    this.actions$.pipe(
      ofType(getExternalSources),
      switchMap(() => {
        if (this.currentUser.user.user_type === UserTypeEnum.TICKETING) {
          return of(setExternalSources({ sources: undefined }));
        }
        return this.apiExternalSharingService.getExternalSources().pipe(
          map(response => {
            if (response.results.length) {
              return setExternalSources({ sources: response.results });
            } else {
              return setExternalSources({ sources: undefined });
            }
          }),
          this.catchHttpError(() => setExternalSources({ sources: undefined })),
        );
      }),
    ),
  );
}
